BOLD.options.app.on('option_products_loaded', function() {
console.log('start check option');
console.log('myOptions = ' + JSON.stringify(myOptions));
console.log('myOption1 = ' + JSON.stringify(myOption1));
console.log('myOption2 = ' + JSON.stringify(myOption2));

  // バリエーションの組み合わせチェック
  checkVariationCombination();

  // 選択の変更を監視
  $('#my-option-1 input, #my-option-2 input').change(function() {
    console.log('change');
      // 一旦クリア
  $('#my-option-1 label').removeClass('not-available-option');
  $('#my-option-2 label').removeClass('not-available-option');
  $('#my-option-1 div.not-available-msg').remove();
  $('#my-option-2 div.not-available-msg').remove();


    checkVariationCombination();
  });

});// end BOLD.options.app.on

function isAvailableOption(myoption1, myoption2) {
  let res = false;
  $.each(myOptions, function(index, elem) {
    if (res) {
      return false; // break;
    }
    $.each(elem, function(option1, option2) {
      // console.log(option1 + ': ' + option2);
      if (myoption1 == option1 && myoption2 == option2) {
        res = true;
        return false; // break;
      }
    });
  });

  return res;
}

function checkVariationCombination() {
  // オプション1の選択値
  var my_selected1 = $('#my-option-1 input:checked').val();
  // オプション2の選択値
  var my_selected2 = $('#my-option-2 input:checked').val();

  // オプション1の選択値に対するオプション2のチェック
  console.log('オプション1の選択値に対するオプション2のチェック');
  $.each(myOption2, function (index, elem) {
    if (! elem) { return true; } // continue;
    if (! isAvailableOption(my_selected1, elem)) {
      console.log(index + ':' + elem);
      disableVariation(2, index);
    }
  });

  // オプション2の選択値に対するオプション1のチェック
  console.log('オプション2の選択値に対するオプション1のチェック');
  $.each(myOption1, function(index, elem) {
    if (! elem) { return true; } // continue;
    if (! isAvailableOption(elem, my_selected2)) {
      console.log(index + ':' + elem);
      disableVariation(1, index);
    }
  });

  return null;
}

function disableVariation(target, nth) {
  // 1つ目のバリエーション
  if (target == 1) {
    $('#my-option-1 label').eq(nth).addClass('not-available-option');
    $('#my-option-1 span.my-option-value').eq(nth).append('<div class="not-available-msg">選択できません</div>')
  }

  // 2つ目のバリエーション
  if (target == 2) {
    $('#my-option-2 label').eq(nth).addClass('not-available-option');
    $('#my-option-2 span.my-option-value').eq(nth).append('<div class="not-available-msg">選択できません</div>')
  }

  return null;
}
